import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: false,
})
export class NotFoundComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  userHomepage: string;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  onHomepageClicked() {
    this.router.navigateByUrl('');
  }
}
